"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiSkeleton = getMuiSkeleton;
function getMuiSkeleton() {
  return {
    defaultProps: {
      animation: 'wave',
      variant: 'rectangular'
    }
  };
}